import { RunTaskEntryType } from '../constants';
export function shouldTriggerWidgetUpdate(newEntries, oldEntries) {
  if (newEntries.length !== oldEntries.length) {
    return true;
  }
  for (let i = 0; i < newEntries.length; i++) {
    const newEntry = newEntries[i];
    const oldEntry = oldEntries[i];
    if (newEntry.type !== oldEntry.type || newEntry.status !== oldEntry.status || newEntry.title !== oldEntry.title) {
      return true;
    }
    if (newEntry.type === RunTaskEntryType.ToolCall) {
      const newToolCall = newEntry;
      const oldToolCall = oldEntry;
      if (newToolCall.message !== oldToolCall.message || newToolCall.inProgress !== oldToolCall.inProgress || newToolCall.approvalId !== oldToolCall.approvalId) {
        return true;
      }
    }
  }
  return false;
}
//# sourceMappingURL=shouldTriggerWidgetUpdate.js.map